(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atlas-main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.add('always-fixed');
				if (this.headerOverlay) {
					this.headerOverlay.classList.add('color-background-1');
					this.headerOverlay.classList.remove('color-inverse');
				}
			};

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				this.headerOverlay.classList.add('color-inverse');
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'input',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}	
					})
					.catch((e) => {
						console.error(e);
					});
			};

			const slideshow = () => {
				if (this.classList.contains("slider_started")) {
					return "";
				}
				this.classList.contains("slider_started");
				const id = this.getAttribute("id");
				
				let swiperParms = {
					loop: false,
					centeredSlides: false,
					autoHeight: false,
					calculateHeight: false,
					keyboard: true,
					navigation: {
						nextEl: `#${id} .swiper-button-next`,
						prevEl: `#${id} .swiper-button-prev`,
					},
					slidesPerView: 1.2,
					spaceBetween: 10,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
					breakpoints: {
						640: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 4,
							spaceBetween: 20,
						},
					},
				};
				new Swiper(`#${id} .swiper`, swiperParms);
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
			new IntersectionObserver(slideshow).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
	class RecentlyViewed extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);
				const productList = JSON.parse(localStorage.getItem('viewedProducts'));
				const wrapper = this.querySelector('.popular-products__wrapper');

				if (productList !== null && productList.value.length > 0) {
					productList.value.forEach((product) => {
						const mediaSrc  = product.media.length > 0 ? product.media[0].src : product.featured_image;
						const mediaAlt = product.media.length > 0 ? product.media[0].alt : product.title;
						const mediaWidth = product.media.length > 0 ? product.media[0].width : 4480;
						const selectedFirstProduct = product.available ? product.variants.find((v) => v.available) : product.variants[0];
						const sale = product.compare_at_price > product.price ? true : false;
						const productLabelText = product.available == false ? '<span class="badge badge--bottom-left" aria-hidden="true">Sold Out</span>' : sale && product.available ? '<span class="badge badge--bottom-left badge-sale" aria-hidden="true">Sale</span>' : '';
						const priceClass = product.available ? 'price' : 'price price--sold-out';
						const salePriceClass = sale ? ' price--on-sale' : '';
						const priceVaries = product.price_varies == false && product.compare_at_price_varies ? ' price--no-compare' : '';

						let quickBuyDiv = '';

						if (product.available) {
							quickBuyDiv = 
								`<product-form class="card__add-to-cart card__button">
									<form method="post" action="/cart/add" id="quick-add-shopify-section-template--19122908594389__product-recently-viewed${ product.id }" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
										<input type="hidden" name="form_type" value="product">
										<input type="hidden" name="utf8" value="✓">
										<input type="hidden" name="id" value="${ selectedFirstProduct.id }">

										<button id="quick-add-shopify-section-template--19122908594389__product-recently-viewed${ product.id }-submit" type="submit" 
											class="card__link button button--primary text-button card__link--hover card-focused" name="add" aria-haspopup="dialog" 
											aria-labelledby="quick-add-shopify-section-template--19122908594389__product-recently-viewed${ product.id }-submit title-shopify-section-template--19122908594389__product-recently-viewed-${ product.id }" 
											aria-live="polite" aria-label="quick-add" data-sold-out-message="true">
											<span class="card__quickview-text button-label">Quick add</span>
												<span class="sold-out-message hidden">Sold Out</span>
												<b class="loading-overlay__spinner hidden">
													<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
														<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
													</svg>
												</b>
										</button>
										<input type="hidden" name="product-id" value="${ product.id }">
										<input type="hidden" name="section-id" value="template--19122908594389__product-recently-viewed">
									</form>
								</product-form>`;
						} else {
							quickBuyDiv = 
								`<div class="quick-add no-js-hidden">
									<modal-opener data-modal="#QuickAdd-${ product.id }">
										<button id="quick-add-shopify-section-template--19122908594389__product-recently-viewed${ product.id }-submit" type="submit" name="add"
											class="card__link button button--primary text-button card__link--hover card-focused" aria-haspopup="dialog" aria-label="quick-view-button"
											aria-labelledby="quick-add-shopify-section-template--19122908594389__product-recently-viewed${ product.id }-submit title-shopify-section-template--19122908594389__product-recently-viewed-${ product.id }" 
											data-product-url="/products/${ product.handle }" data-modal-open="QuickAdd-${ product.id }"
										>
											Quick view
											<b class="loading-overlay__spinner hidden">
												<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
													<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
												</svg>
											</b>
										</button>
									</modal-opener>

									<quick-add-modal id="QuickAdd-${ product.id }" class="quick-add-modal">
										<div role="dialog" aria-label="${ product.title }" aria-modal="true" class="quick-add-modal__content global-settings-popup">
											<div class="quick-add-modal_top">
												<p class="subtitle">Quick view</p>
												<button id="ModalClose-${ product.id }" type="button" class="quick-add-modal__toggle modal-close-button" aria-label="Close" tabindex="-1">
													<svg width="19" height="19" viewBox="0 0 19 19" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M14.5625 4.4375L4.4375 14.5625" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
														<path d="M14.5625 14.5625L4.4375 4.4375" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
													</svg>
												</button>
											</div>
											<div class="quick-add-modal__content-wrapper">
												<div id="QuickAddInfo-${ product.id }" class="quick-add-modal__content-info"></div>
											</div>
										</div>

										<div class="button-view-full">
											<a href="/products/${ product.handle }" class="button button--simple">
												<span class="button-label">View Full Details</span>
												<span class="button-icon">
													<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-button-arrow">
														<path d="M8.22917 3.75L11.875 7.5M11.875 7.5L8.22917 11.25M11.875 7.5L3.125 7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</span>
											</a>
										</div>
									</quick-add-modal>
								</div>`;
						};

						let productCard = 
						`<div class="popular-products__item border-item swiper-slide">
							<div  class="product-card card-wrapper js-color-swatches-wrapper quickview--hover" data-product="${ product.handle }">
								<span class="visually-hidden">${ product.title }</span>
								<div class="card card--product" tabindex="-1">
									<a 
										href="/products/${ product.handle }" 
										class="media media--hover-effect js-color-swatches-link"
										aria-label="Product link" 
										style="padding-bottom: 70%; --image-size-mob: 130%;"
									>
										<img src="${ mediaSrc }&amp;width=1920" 
											alt="${ mediaAlt }" 
											srcset="${ mediaSrc }&amp;width=375 375w, ${ mediaSrc }&amp;width=550 550w, ${ mediaSrc }&amp;width=750 750w, ${ mediaSrc }&amp;width=1100 1100w, ${ mediaSrc }&amp;width=1500 1500w, ${ mediaSrc }&amp;width=1700 1700w, ${ mediaSrc }&amp;width=1900 1900w" 
											width="${ mediaWidth }" loading="lazy" sizes="(max-width: 576px) 100vw, (max-width: 1200px) 50vw, 100vw" 
											class="motion-reduce media--first" 
											style="object-position: 50.0% 50.0%; object-fit : cover;">

										<img src="${ mediaSrc }&amp;width=1920" 
											alt="${ mediaAlt }" 
											srcset="${ mediaSrc }&amp;width=375 375w, ${ mediaSrc }&amp;width=550 550w, ${ mediaSrc }&amp;width=750 750w, ${ mediaSrc }&amp;width=1100 1100w, ${ mediaSrc }&amp;width=1500 1500w, ${ mediaSrc }&amp;width=1700 1700w, ${ mediaSrc }&amp;width=1900 1900w" 
											width="${ mediaWidth }" loading="lazy" sizes="(max-width: 576px) 100vw, (max-width: 1200px) 50vw, 100vw" 
											class="motion-reduce media--second" 
											style="object-position: 50.0% 50.0%; object-fit : cover;">
									</a>
									${ quickBuyDiv }
									<div class="card__badge h6 medium-font">${ productLabelText }</div>
								</div>
								<div class="card-information">
									<div class="card-information__wrapper">
										<span class="visually-hidden">Vendor:</span>
										<div class="caption-with-letter-spacing subtitle">${ product.vendor }</div>
										<div class="card-information-block">
											<h3 class="card__title">
												<a class="unstyled-link" href="/products/${ product.handle }" title="${ product.title }">${ product.title }</a>
											</h3>
											<div class="${ priceClass }${ salePriceClass }${ priceVaries }">
												<dl>
													<div class="price__regular">
														<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>
														<dd><span class="price-item price-item--regular">${ selectedFirstProduct.price }</span></dd>
													</div>
													<div class="price__sale">
														<dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt>
														<dd><span class="price-item price-item--sale">${ selectedFirstProduct.price }</span></dd>
														<dt class="price__compare">
															<span class="visually-hidden visually-hidden--inline">Regular price</span>
														</dt>
														<dd class="price__compare">
															<span class="price-item price-item--regular">${ product.compare_at_price }</span>
														</dd>
													</div>
												</dl>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>`;

						wrapper.innerHTML += productCard;
					});
				};
			};

			const slideshow = () => {
				if (this.classList.contains("slider_started")) {
					return "";
				}
				this.classList.contains("slider_started");
				const id = this.getAttribute("id");
				
				let swiperParms = {
					loop: false,
					centeredSlides: false,
					autoHeight: false,
					calculateHeight: false,
					keyboard: true,
					navigation: {
						nextEl: `#${id} .swiper-button-next`,
						prevEl: `#${id} .swiper-button-prev`,
					},
					slidesPerView: 1.2,
					spaceBetween: 10,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
					breakpoints: {
						640: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 4,
							spaceBetween: 20,
						},
					},
				};
				new Swiper(`#${id} .swiper`, swiperParms);
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
			new IntersectionObserver(slideshow).observe(this);
		}
	}

	customElements.define('recently-viewed', RecentlyViewed);

  } catch(e) { console.error(e); }
})();
})();
